import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section id="cta" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="p-10 md:p-16 rounded-lg bg-primary-500">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-background-50 dark:text-foreground-950 mb-3">
            {t('home.cta.title')}
          </h2>
          <p className="text-base md:text-lg text-background-50/85 dark:text-foreground-950/85 max-w-xl mx-auto mb-8">
            {t('home.cta.subtitle')}
          </p>
          <a
            href="#"
            className="inline-block px-10 py-4 bg-background-50 text-primary-600 rounded-md text-base font-semibold hover:bg-background-100 transition-all duration-200 whitespace-nowrap shadow-lg"
          >
            {t('home.cta.button')}
          </a>
          <p className="mt-4 text-sm text-background-50/65 dark:text-foreground-950/65">
            无需绑定信用卡 · 14 天全功能试用
          </p>
        </div>
      </div>
    </section>
  );
}